import { CLEAR, REPLACE, SET_CASHREGISTERS_FILTERS, SET_CASHREGISTERS_PAGENUMBER, SET_CASHREGISTERS_PAGESIZE } from "./actions"

const initialState = {
    cashRegisters : [],
    totalResults: 0,
    totalPage: 1,
    pageSize: 100,
    pageNumber: 1,
    filters: {
        name: '',
        branchId: '',
        from: '',
        to: '',
    }
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE:
            return {
                ...state,
                cashRegisters: action.cashRegisters,
                totalResults: action.totalResults,
                totalPage: action.totalPage
            }
        case SET_CASHREGISTERS_FILTERS:
            return {
                ...state,
                pageNumber: 1,
                filters: {
                    ...state.filters,
                    ...action.filters
                }
            }
        case SET_CASHREGISTERS_PAGESIZE:
            return {
                ...state,
                pageSize: action.pageSize
            }
        case SET_CASHREGISTERS_PAGENUMBER:
            return {
                ...state,
                pageNumber: action.pageNumber
            }
        case CLEAR:
            return initialState
        default:
            return state;
    }
}